import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { injectConfigs } from '../../../core/config/utils';

@Component({
  selector: 'app-force-claim-change',
  templateUrl: './force-claim-change.component.html',
  styleUrls: ['./force-claim-change.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForceClaimChangeComponent {
  _auth = inject(AuthService);
  logout() {
    this._auth.logout();
  }
}
